import type { getSubTotalPrice } from '@/api/cart';
import {
  buildCartAutoOfferParams,
  clearFailedCouponSelection,
  mergeAppliedOfferIntoState,
  resolveCartOfferAfterPricingFailure,
  type AutoOfferStore,
} from './index';

type QuoteResponse = Awaited<ReturnType<typeof getSubTotalPrice>>;
type QuoteRequest = (params: ReturnType<typeof buildCartAutoOfferParams>) => Promise<QuoteResponse>;

/**
 * 只对已有明确券失效码恢复一次；普通失败、缺少 applied_offer 或 applied=false 都不代表券失效。
 * request 由调用方校验当前账户和计价输入是否仍有效，首次请求与恢复重试都必须经过该校验。
 */
export async function requestCartOfferQuote(selection: AutoOfferStore, request: QuoteRequest) {
  let current = selection;
  try {
    let response = await request(buildCartAutoOfferParams(current));
    if (response?.code === 400200) {
      // 仅手动券/码会恢复默认策略；主动取消不恢复，积分选择不变，第二次失败也不继续重试。
      const restored = clearFailedCouponSelection(current, true);
      if (restored !== current) {
        current = restored;
        response = await request(buildCartAutoOfferParams(current));
      }
    }
    const subtotal = response?.data?.subtotal;
    if (
      response?.code !== 200 ||
      subtotal === undefined ||
      subtotal === null ||
      subtotal === '' ||
      !Number.isFinite(Number(subtotal)) ||
      Number(subtotal) < 0
    ) {
      return { status: 'error' as const, selection: resolveCartOfferAfterPricingFailure(current) };
    }
    return {
      status: 'success' as const,
      data: response.data,
      selection: mergeAppliedOfferIntoState(current, response.data.applied_offer),
    };
  } catch {
    return { status: 'error' as const, selection: resolveCartOfferAfterPricingFailure(current) };
  }
}
